import { DIALOG_CONTACTOLOGIA } from "../consts";

const mydialog = {  
    open: false,
    id: 0, 
    editable: true,
    clientId : 0
}

export default function contactologiaReducer(state = mydialog, { type, payload }) {
    const actions = {
        [DIALOG_CONTACTOLOGIA] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}

export const updateContactologia = contactologia    => ({
    type: DIALOG_CONTACTOLOGIA,
    payload: contactologia
});
